/**
 * @generated SignedSource<<a85efb8a1c89ba961e2e375aea006719>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedCreatorBuyPages_creatorRootPage$data = {
  readonly relatedCreatorBuyPages: ReadonlyArray<{
    readonly relatedCreatorBuyPage: {
      readonly creatorBuyPageFirstItem: {
        readonly photos: ReadonlyArray<{
          readonly smallPath: string | null;
        } | null> | null;
      } | null;
      readonly creatorBuyPageLinkData: {
        readonly text: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
      };
    } | null;
  } | null> | null;
  readonly " $fragmentType": "SbSharedRelatedCreatorBuyPages_creatorRootPage";
};
export type SbSharedRelatedCreatorBuyPages_creatorRootPage$key = {
  readonly " $data"?: SbSharedRelatedCreatorBuyPages_creatorRootPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedCreatorBuyPages_creatorRootPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "relatedBuyPagesCount"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedCreatorBuyPages_creatorRootPage",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "relatedBuyPagesCount",
          "variableName": "relatedBuyPagesCount"
        }
      ],
      "concreteType": "RelatedCreatorBuyPages",
      "kind": "LinkedField",
      "name": "relatedCreatorBuyPages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RelatedCreatorBuyPage",
          "kind": "LinkedField",
          "name": "relatedCreatorBuyPage",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkData",
              "kind": "LinkedField",
              "name": "creatorBuyPageLinkData",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SeoLink_linkData"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "text",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "creatorBuyPageFirstItem",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "limit",
                      "value": 1
                    }
                  ],
                  "concreteType": "ItemPhoto",
                  "kind": "LinkedField",
                  "name": "photos",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "smallPath",
                      "storageKey": null
                    }
                  ],
                  "storageKey": "photos(limit:1)"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CreatorRootPage",
  "abstractKey": null
};

(node as any).hash = "434598bf9325a6956dcb5db34197243d";

export default node;
